/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SpuUpdateReqVo
 */
export interface SpuUpdateReqVo {
    /**
     * SPU ID
     * @type {number}
     * @memberof SpuUpdateReqVo
     */
    spuId: number;
    /**
     * SPU名称
     * @type {string}
     * @memberof SpuUpdateReqVo
     */
    name?: string;
    /**
     * 产地标签：Y-原产地，N-非原产地
     * @type {string}
     * @memberof SpuUpdateReqVo
     */
    originLabel?: string;
    /**
     * 是否年满14岁：Y-年满，N-未满
     * @type {string}
     * @memberof SpuUpdateReqVo
     */
    underFourteenYearsOld?: string;
    /**
     * 有效期标识：Y-有保质期，N-无保质期
     * @type {string}
     * @memberof SpuUpdateReqVo
     */
    validPeriod?: string;
}

/**
 * Check if a given object implements the SpuUpdateReqVo interface.
 */
export function instanceOfSpuUpdateReqVo(value: object): value is SpuUpdateReqVo {
    if (!('spuId' in value) || value['spuId'] === undefined) return false;
    return true;
}

export function SpuUpdateReqVoFromJSON(json: any): SpuUpdateReqVo {
    return SpuUpdateReqVoFromJSONTyped(json, false);
}

export function SpuUpdateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpuUpdateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'spuId': json['spuId'],
        'name': json['name'] == null ? undefined : json['name'],
        'originLabel': json['originLabel'] == null ? undefined : json['originLabel'],
        'underFourteenYearsOld': json['underFourteenYearsOld'] == null ? undefined : json['underFourteenYearsOld'],
        'validPeriod': json['validPeriod'] == null ? undefined : json['validPeriod'],
    };
}

export function SpuUpdateReqVoToJSON(json: any): SpuUpdateReqVo {
    return SpuUpdateReqVoToJSONTyped(json, false);
}

export function SpuUpdateReqVoToJSONTyped(value?: SpuUpdateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'spuId': value['spuId'],
        'name': value['name'],
        'originLabel': value['originLabel'],
        'underFourteenYearsOld': value['underFourteenYearsOld'],
        'validPeriod': value['validPeriod'],
    };
}

